// eslint-disable-next-line import/prefer-default-export
export const GLYMPSE_PRO_CHAT_ORIGIN = 'glympse-pro';

export const CHAT_SOUND_NOTIFICATIONS = 'chat-sound-notifications';

export const CONTACT_INFO_FIELDS = (labels) => [{
  key: 'id',
  title: 'Glympse #'
},
  {
    key: 'appointment_id',
    title: `${labels.task} #`
  },
  {
    key: 'destination',
    title: 'Destination'
  },
  {
    key: 'description',
    title: 'description'
  }];

export const CONTACT_SEARCH_FIELDS = ['customer', 'id', 'appointment_id', 'destination', 'description'];
